module.exports = __webpack_public_path__ + "img/Qspades.ea7b0e4d.jpg";